import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQ } from "@/data/site";
import { SectionHead } from "./Sections";

export function Faq() {
  return (
    <section id="faq" data-testid="section-faq" className="py-20 md:py-28 border-t border-[#1E2D4A]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4"><SectionHead eyebrow="FAQ" title="Questions engineers ask." /></div>
        <Accordion type="single" collapsible className="lg:col-span-8">
          {FAQ.map((f, i) => (
            <AccordionItem key={f.q} value={`q${i}`} className="border-[#1E2D4A]">
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left font-heading text-lg text-slate-100 hover:no-underline hover:text-amber-400">{f.q}</AccordionTrigger>
              <AccordionContent className="text-slate-400 text-base leading-relaxed">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
